module.exports = __webpack_public_path__ + "static/media/0222_IMG_LES_MURS_SLOE_W_VSL2100_CHEVRON.8b942a16.png";